module.exports = __webpack_public_path__ + "img/phone.b11f2101.svg";